export default __webpack_public_path__ + "static/media/4.ed31fe6f.png";